import {useEffect, useState} from "react"

export interface SegmentInfo {
    name: string
    description: string
    distance: number
}

interface SegmentInfoPanelProps {
    segmentInfo: SegmentInfo | null
}

export const SegmentInfoPanel: React.FC<SegmentInfoPanelProps> = ({segmentInfo}) => {
    const [isExpanded, setIsExpanded] = useState(false)

    if (!segmentInfo) return null

    return (
        <div className="fixed right-4 top-4 z-50" onClick={() => setIsExpanded(!isExpanded)}>
            <div
                className={`
              cursor-pointer rounded-lg bg-white shadow-lg transition-all duration-200 ease-in-out
              ${isExpanded ? "w-80 p-4" : "w-auto p-2"}
          `}
            >
                <div className="flex items-center justify-between">
                    <span className="font-medium text-gray-800">{segmentInfo.name}</span>
                    <span className="ml-2 text-sm text-gray-500">{segmentInfo.distance.toFixed(2)}</span>
                </div>

                {isExpanded && (
                    <div className="mt-3">
                        <div className="text-sm text-gray-600">{segmentInfo.description}</div>
                    </div>
                )}
            </div>
        </div>
    )
}
